import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useSnackbar } from 'notistack';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ListItem from '../modal-list-item/modal-list-item.component';
import { addOrder } from '../../redux/thunks/orders';
import { List } from './new-order-modal.styles';
import { isURLValid, correctURLToHttpsProtocol } from '../../utils/helpers/valid';

const NewOrderModal = ({ show, onClose, primaryDomain, selectedBacklinks, isDisabled, orderId }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [orderData, setOrderData] = useState({});

  const handleFormChange = (_id, name, value) => {
    const existingData = orderData[_id] || {};
    setOrderData({ ...orderData, 
      [_id]: {
        ...existingData,
        [name]: value
      }
    });
  };

  const handleSend = () => {
    const onSuccess = (message) => {
      enqueueSnackbar(message, { variant: 'success' });
      onClose();
    };
    const onError = (message) => enqueueSnackbar(message, { variant: 'error' });

    if (Object.keys(orderData).length !== selectedBacklinks.length) {
      onError('נא למלא את כל השדות');
      return;
    }

    const requiredFields = [{
      name: 'anchor',
      value: 'אנקור',
      isValid: (value) => value && value.length && value.trim().length > 0
    }, {
      name: 'link',
      value: 'קישור',
      isValid: (value) => isURLValid(value)
    }];
    const optionalFields = [{
      name: 'notes',
      value: 'הערות',
      isValid: (value) => value && value.length && value.trim().length > 0
    }];

    for (const _id in orderData) {
      const data = orderData[_id];
      for (const field of requiredFields) {
        if (!data[field.name]) {
          onError(`נא למלא את השדה ${field}`);
          return;
        }

        if (!field.isValid(data[field.name])) {
          onError(`נא למלא את השדה ${field.value} באופן תקין`);
          return;
        }
      }

      for (const field of optionalFields) {
        if ((data[field.name] !== null || data[field.name] !== undefined) && !field.isValid(data[field.name])) {
          delete data[field.name];
          orderData[_id] = data;
        }
      }
    }

    const backlinksOrder = Object.entries(orderData).map(([_id, data]) => ({
      ...data,
      backlinkId: _id,
    }));

    dispatch(addOrder({
      formData: {
        domain: primaryDomain,
        backlinks: backlinksOrder
      },
      onSuccess,
      onError
    }));
  };

  return (<Modal
    show={show}
    onHide={onClose}
  >
    <Modal.Header>
      <Modal.Title>{isDisabled ? `פרטי הזמנה (${orderId})` : 'מילוי פרטי הזמנה'}</Modal.Title>
    </Modal.Header>
    <Modal.Body style={{ padding: 0 }}>
      {selectedBacklinks.length > 0 && (
        <List>
          {selectedBacklinks.map(({ domain, _id, anchor, url, notes }) => (<ListItem label={domain} key={_id}>
            <Card>
              <Card.Body>
                <Card.Text>
                  <Form.Group>
                    <Form.Label>אנקור</Form.Label>
                    <Form.Control as={'input'} placeholder={'אנקור'} disabled={isDisabled} onChange={(e) => handleFormChange(_id, 'anchor', e.target.value)} defaultValue={anchor ?? ''} />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>{isDisabled ? <a href={correctURLToHttpsProtocol(url)} target="_blank">קישור</a> : 'קישור'}</Form.Label>
                    <Form.Control as={'input'} placeholder={'קישור'} disabled={isDisabled} onChange={(e) => handleFormChange(_id, 'link', e.target.value)} defaultValue={url ?? ''} />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>הערות</Form.Label>
                    <Form.Control as={'textarea'} placeholder={'הערות'} disabled={isDisabled} onChange={(e) => handleFormChange(_id, 'notes', e.target.value)} defaultValue={notes ?? ''} />
                  </Form.Group>
                </Card.Text>
              </Card.Body>
            </Card>
          </ListItem>))}
        </List>
      )}
    </Modal.Body>
    <Modal.Footer>
      {!isDisabled && <Button variant="primary" onClick={handleSend}>שליחה לביצוע</Button>}
      <Button variant="secondary" onClick={onClose}>{isDisabled ? 'סגור' : 'בטל'}</Button>
    </Modal.Footer>
  </Modal>);
};

export default NewOrderModal;
